export default __webpack_public_path__ + "static/blogBG4-mobile-3dcf8c594ab33c6f08f40d19aead85e4.svg";